// extracted by mini-css-extract-plugin
export default {"content":"AttachedFailureCard_content__fr--i","identifier":"AttachedFailureCard_identifier__iI9FX","address":"AttachedFailureCard_address__fvD-V"};